// //utils/getcaptchcatoken.js

// export const getRecaptchaToken = async (action = "contact_submit") => {
//   const siteKey = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY;
//   if (!siteKey) throw new Error("Missing NEXT_PUBLIC_RECAPTCHA_SITE_KEY");

//   // wait until grecaptcha is ready
//   await new Promise((resolve) => {
//     if (window.grecaptcha?.ready) return window.grecaptcha.ready(resolve);
//     // fallback if script not loaded yet
//     const t = setInterval(() => {
//       if (window.grecaptcha?.ready) {
//         clearInterval(t);
//         window.grecaptcha.ready(resolve);
//       }
//     }, 50);
//   });

//   return window.grecaptcha.execute(siteKey, { action });
// };

// utils/getcapthcatoken.js

const siteKey = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY;

// Module-level cache — shared across every import of this file across
// the whole app, so the reCAPTCHA script is only ever injected once,
// no matter how many forms/pages call getRecaptchaToken() or
// preloadRecaptcha().
let scriptPromise = null;

function loadScript() {
  if (typeof window === "undefined") {
    return Promise.reject(new Error("No window"));
  }

  if (window.grecaptcha) {
    return Promise.resolve();
  }

  if (scriptPromise) {
    return scriptPromise;
  }

  scriptPromise = new Promise((resolve, reject) => {
    // Avoid injecting a duplicate <script> tag if something else
    // (e.g. a fast double-call) already added it before this promise
    // resolved.
    const existing = document.querySelector(
      `script[src^="https://www.google.com/recaptcha/api.js"]`,
    );

    if (existing) {
      existing.addEventListener("load", resolve);
      existing.addEventListener("error", reject);
      return;
    }

    const script = document.createElement("script");
    script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
    script.async = true;
    script.onload = resolve;
    script.onerror = () => {
      scriptPromise = null; // allow retry on next call if this load failed
      reject(new Error("Failed to load reCAPTCHA script"));
    };
    document.head.appendChild(script);
  });

  return scriptPromise;
}

/**
 * Loads reCAPTCHA (if not already loaded) and returns an execution token
 * for the given action. Call this at submit time in any form on the site.
 *
 * Safe to call from multiple forms/components simultaneously — the
 * underlying script load is deduplicated via scriptPromise.
 */
export const getRecaptchaToken = async (action = "contact_submit") => {
  if (!siteKey) {
    throw new Error("Missing NEXT_PUBLIC_RECAPTCHA_SITE_KEY");
  }

  await loadScript();

  await new Promise((resolve) => {
    window.grecaptcha.ready(resolve);
  });

  return window.grecaptcha.execute(siteKey, { action });
};

/**
 * Optional: call this on first user interaction with a form (e.g. onFocus
 * of any field) to start loading the script a moment before submit, so
 * getRecaptchaToken() doesn't have to wait on the network fetch when the
 * user actually clicks submit. Safe to call repeatedly — it's a no-op
 * after the first successful load.
 */
export const preloadRecaptcha = () => {
  if (!siteKey) return;
  loadScript().catch(() => {
    // swallow errors here; getRecaptchaToken will surface them properly
    // when it's actually needed at submit time
  });
};
